export default "__VITE_ASSET__BXguNKfQ__"